export class APIErrorResponse {
  message: string;
  messageKey?: string;
  metadata?: Record<string, unknown>;
  statusCode?: number;
  constructor(data: ErrorData) {
    this.message = data.message;
    this.messageKey = data.messageKey;
    this.metadata = data.metadata;
    this.statusCode = data.statusCode || 500; // Defaults to 500 if not provided. Internal Server Error.
  }
}

interface ErrorData {
  message: string;
  messageKey?: string;
  metadata?: Record<string, unknown>;
  statusCode?: number;
}
